import React from 'react'
import Layout from '../../components/layout'
import Container from '../../components/container'
// import styled from '@emotion/styled'

const AstroPage = () => {
  return (
    <Layout>
      <Container>
        <p>This is the Astro Page</p>
      </Container>
    </Layout>
  );
}

export default AstroPage
